import { IMarketYoyGrowthGeoMarketApi, TMarketYoyGrowthExpectationMarket } from '../api/types'
import { IMarketYoyGrowthGeoMarket } from '../model/types'

export const mapMarketYoyGrowthGeoMarketFromApi = (
  data: IMarketYoyGrowthGeoMarketApi
): IMarketYoyGrowthGeoMarket => ({
  name: data.GeoMarket,
  order: data.GeoMarketOrder,
  short: data.GeoMarketShort as TMarketYoyGrowthExpectationMarket,
})
